import axios from 'axios'
import router from './router'

function getBaseURL(config) {
  if (config.data && config.data.extsysCode == 100000010) {
    return process.env.VUE_APP_BASE_API
  } else {
    return process.env.VUE_APP_BASE_API
  }
}

// axios 配置
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_BASE_API
  // 超时
  // timeout: 10000,VUE_APP_DATA_API
})
// http request 拦截器
service.interceptors.request.use(
  config => {
    // if (config.url == 'ffsapp-service/pasture/list') {
    //   config.headers.Authorization = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxODAwOTI3NjI3MyIsImV4cCI6MTY3MzU5NDg0NTQxNSwiaWF0IjoxNjcxMDAyODQ1NDE1LCJqdGkiOiI0MDQyOTc2ODk0NTYzMTY0MTYiLCJsb2dpbl91c2VyX2tleSI6IjYwYzliZGQ1LTQ1NTgtNDk2MS05ODY2LWJmZTc5YzRlYmUzNyJ9.7gipzJus_1DQdVgHVXw2eIKqsjmNZ-v1C8XOTPnYQPJ2FtIAKVNLBO0F4Vlo9v1T_wqRmT1_F6DZEVzOV_CDgQ';
    // } else {
    //   config.headers.Authorization = window.localStorage.getItem('NMYDATAASSTSTOKEN') || '';
    // }

    // const urlList = ['https://gateway.east-mind.com/ffsapp-service/pasture/selectPastureVideo', 'https://gateway.east-mind.com/ffsapp-service/pasture/getLiveVideoUrl',
    //   'https://gateway.east-mind.com/ffsapp-service/ezviz/getPlayUrl', 'https://gateway.east-mind.com/ffsapp-service/pasture/getPlayUrl'
    // ]
    // const url = urlList.find((item) => {
    //   return item === config.url
    // })
    // if (url != undefined) {
    //   config.headers.Authorization = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxODAwOTI3NjI3MyIsImV4cCI6MTY3MTAwMDMwMDM0MiwiaWF0IjoxNjY4NDA4MzAwMzQyLCJqdGkiOiI0MDQyOTc2ODk0NTYzMTY0MTYiLCJsb2dpbl91c2VyX2tleSI6IjIwNjgxYmNhLTUwNTAtNGY4Zi1hZDk4LWQxMzllOWJkNmI5NiJ9.jmYleOViZRvHofRwAwuppHPSOEdh_Btx-1YPfgHgclVcUSC4o9AKKvFjxmQqhUu74QxqmBHJWSIT7BYYj83dPQ';
    // } else {
    //   config.headers.Authorization = window.localStorage.getItem('NMYDATAASSTSTOKEN') || '';
    // }
    config.headers.Authorization = window.localStorage.getItem('NMYDATAASSTSTOKEN') || '';
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    // config.headers["Access-Control-Allow-Origin"] = 'http://120.46.143.129';//后加的
    config.baseURL = getBaseURL(config);
    return config
  },
  err => {
    return Promise.reject(err)
  },
)
// http response 拦截器
service.interceptors.response.use(
  data => {
    if (data.data.code === 201) {
      window.sessionStorage.removeItem('NMYDATAASSTSTOKEN')
      window.sessionStorage.removeItem('mapfileUrl')
      router.currentRoute.path !== 'login' &&
        router.replace({
          path: 'login',
          query: { redirect: router.currentRoute.path },
        })
    }
  // 通辽大屏
    if(data.data.code === 401&&window.localStorage.getItem('TL')&&window.localStorage.getItem('TL')=='tldp'){
      location.href='/source'
    }
	if(data.data.code === 401&&window.localStorage.getItem('APP')=='WMS'){
		location.href=process.env.VUE_APP_WMS_WEB
	}
	if(data.config.data&&data.config.data.includes('wms')){
		return data.data
	}
    return data
  },
  error => {
    if (error.response) {
      console.log(error)
      switch (error.response.status) {
        case 201:
          router.currentRoute.path !== 'login' &&
            router.replace({
              path: 'login',
              query: { redirect: router.currentRoute.path },
            })
      }
    }
    return Promise.reject(error.response.data)
  },
)

export default service
